const atualizarCentrosCusto = (state, centrosCusto) => {
    state.centrosCusto = centrosCusto;
}

const atualizarCentroCusto = (state, centroCusto) => {
    state.centroCusto = centroCusto;
}

const addCentroCusto = (state, centroCusto) => {
    if (!centroCusto || centroCusto.id == null) return;

    state.centrosCusto.push(JSON.parse(JSON.stringify(centroCusto)));
}

const updateCentroCusto = (state, centroCusto) => {
    if (!centroCusto || centroCusto.id == null) return;

    const index = state.centrosCusto.findIndex(item => item.id === centroCusto.id);
    if (index >= 0) {
        state.centrosCusto.splice(index, 1, JSON.parse(JSON.stringify(centroCusto)));
    }
}

export default {
    atualizarCentrosCusto,
    atualizarCentroCusto,
    addCentroCusto,
    updateCentroCusto
}
